__turbopack_context__.v({
  "className": "inter_5994726-module__Xoiqna__className",
  "variable": "inter_5994726-module__Xoiqna__variable",
});
